import { useState } from 'react';
import Header from '../components/header';
import './home.css';

import villa1 from '../assets/villa1.png';
import villa2 from '../assets/villa2.png';
import villa3 from '../assets/villa3.png';
import villa4 from '../assets/villa4.png';
import villa5 from '../assets/villa5.png';
import villa6 from '../assets/villa6.png';
import villa7 from '../assets/villa7.png';
import villa8 from '../assets/villa8.png';
import villa9 from '../assets/villa9.png';
import villa10 from '../assets/villa10.png';
import villa11 from '../assets/villa11.png';
import villa12 from '../assets/villa12.png';

const PROPERTIES = [
  {
    id: 1,
    title: 'Skyline Penthouse',
    type: 'Penthouse',
    status: 'For Sale',
    price: '$4,500,000',
    short: '$4.5M',
    location: 'Downtown, New York',
    beds: 4, baths: 3, area: '3,200',
    year: 2022,
    tag: 'Featured',
    img: villa1,
    img2: villa2,
    desc: "A breathtaking penthouse perched atop one of Manhattan's most iconic towers. Floor-to-ceiling glass walls offer panoramic city views, while the open-plan interior blends smart home technology with bespoke finishes. Features a private rooftop terrace, home cinema, and dedicated concierge service.",
    features: ['Private Rooftop Terrace', 'Smart Home System', 'Home Cinema', '24/7 Concierge', 'Private Elevator', 'Wine Cellar'],
    agent: { name: 'Alexandra Reid', initials: 'AR', phone: '+1 (212) 555-0191', email: 'a.reid@novarealty.com' },
  },
  {
    id: 2,
    title: 'The Glass Villa',
    type: 'Villa',
    status: 'For Sale',
    price: '$7,200,000',
    short: '$7.2M',
    location: 'Beverly Hills, CA',
    beds: 6, baths: 5, area: '6,800',
    year: 2021,
    tag: 'Luxury',
    img: villa3,
    img2: villa4,
    desc: "An architectural masterpiece nestled in the hills of Beverly Hills. This contemporary villa features a transparent facade that merges interior living with outdoor landscaped gardens. Includes an infinity pool, home gym, and professional chef's kitchen.",
    features: ['Infinity Pool', 'Home Gym', "Chef's Kitchen", 'Guest House', 'Landscaped Garden', '4-Car Garage'],
    agent: { name: 'Marcus Cole', initials: 'MC', phone: '+1 (310) 555-0142', email: 'm.cole@novarealty.com' },
  },
  {
    id: 3,
    title: 'Harbor View Loft',
    type: 'Loft',
    status: 'For Rent',
    price: '$8,500/mo',
    short: '$8,500/mo',
    location: 'Marina District, San Francisco',
    beds: 2, baths: 2, area: '1,800',
    year: 2020,
    tag: 'New',
    img: villa5,
    img2: villa6,
    desc: 'A stunning industrial-chic loft with unobstructed harbor views. Exposed concrete ceilings meet warm oak floors throughout the open-plan living space. A designer kitchen, private balcony, and secure parking make this a standout urban retreat.',
    features: ['Harbor Views', 'Private Balcony', 'Exposed Concrete', 'Designer Kitchen', 'Secure Parking', 'Pet Friendly'],
    agent: { name: 'Priya Nair', initials: 'PN', phone: '+1 (415) 555-0177', email: 'p.nair@novarealty.com' },
  },
  {
    id: 4,
    title: 'Meridian Tower Suite',
    type: 'Apartment',
    status: 'For Sale',
    price: '$1,850,000',
    short: '$1.85M',
    location: 'Midtown, Chicago',
    beds: 3, baths: 2, area: '2,100',
    year: 2023,
    tag: 'New',
    img: villa7,
    img2: villa8,
    desc: 'A refined city apartment in the award-winning Meridian Tower. The thoughtful layout maximizes natural light through oversized windows, with premium finishes throughout. Building amenities include a rooftop lounge, fitness center, and valet parking.',
    features: ['Rooftop Lounge', 'Fitness Center', 'Valet Parking', 'Concierge', 'City Views', 'In-unit Laundry'],
    agent: { name: 'James Whitfield', initials: 'JW', phone: '+1 (312) 555-0163', email: 'j.whitfield@novarealty.com' },
  },
  {
    id: 5,
    title: 'Oceanfront Estate',
    type: 'Villa',
    status: 'For Sale',
    price: '$12,000,000',
    short: '$12M',
    location: 'Malibu, CA',
    beds: 7, baths: 6, area: '9,200',
    year: 2019,
    tag: 'Exclusive',
    img: villa9,
    img2: villa10,
    desc: 'A once-in-a-generation beachfront estate commanding over 100 feet of private Malibu coastline. The sprawling compound features a main residence, guest cottage, private beach access, and a resort-style pool area with cabana.',
    features: ['100ft Beach Frontage', 'Private Beach', 'Guest Cottage', 'Resort Pool', 'Home Theater', 'Staff Quarters'],
    agent: { name: 'Sofia Marchetti', initials: 'SM', phone: '+1 (424) 555-0188', email: 's.marchetti@novarealty.com' },
  },
  {
    id: 6,
    title: 'Urban Studio Pod',
    type: 'Studio',
    status: 'For Rent',
    price: '$3,200/mo',
    short: '$3,200/mo',
    location: 'Brooklyn, New York',
    beds: 1, baths: 1, area: '620',
    year: 2023,
    tag: null,
    img: villa11,
    img2: villa12,
    desc: 'A thoughtfully designed micro-luxury studio in the heart of Brooklyn. Every square foot has been maximized through smart storage solutions and convertible furniture. A south-facing window wall floods the space with natural light.',
    features: ['Smart Storage', 'South-facing Windows', 'Bike Storage', 'Roof Access', 'Fiber Internet', 'Walk to Subway'],
    agent: { name: 'Danny Park', initials: 'DP', phone: '+1 (718) 555-0122', email: 'd.park@novarealty.com' },
  },
];


function Card({ p, onView }) {
  return (
    <div className="card" onClick={() => onView(p)}>
      <div className="cardimg">
        <img src={p.img} alt={p.title} loading="lazy" />
        <div className="cardstatus">{p.status}</div>
        {p.tag && <div className="cardtag">{p.tag}</div>}
        <div className="cardtype">{p.type}</div>
      </div>
      <div className="cardbody">
        <div className="cardprice">{p.short}</div>
        <h3 className="cardtitle">{p.title}</h3>
        <p className="cardloc">◎ {p.location}</p>
        <div className="cardspecs">
          <span><strong>{p.beds}</strong> Beds</span>
          <span className="dot" />
          <span><strong>{p.baths}</strong> Baths</span>
          <span className="dot" />
          <span><strong>{p.area}</strong> ft²</span>
        </div>
      </div>
    </div>
  );
}


function Footer({ setPage }) {
  return (
    <footer className="footer">
      <div className="footergrid">
        <div className="footerbrand">
          <div className="footerlogo">
            <span className="footerbox">N</span>
            <span className="footername">NOVA<em>Realty</em></span>
          </div>
          <p className="footertag">Connecting discerning clients with extraordinary properties since 2009.</p>
        </div>
        <div className="footercol">
          <p className="footerhead">Navigate</p>
          <button className="footerlink" onClick={() => setPage('home')}>Home</button>
          <button className="footerlink" onClick={() => setPage('properties')}>Properties</button>
        </div>
        <div className="footercol">
          <p className="footerhead">Contact</p>
          <span className="footerlink">+1 (212) 555-0100</span>
          <span className="footerlink">hello@novarealty.com</span>
          <span className="footerlink">350 Fifth Ave, New York</span>
        </div>
      </div>
      <div className="footerbottom">
        <p>© 2024 NOVARealty. All rights reserved.</p>
        <div className="footerlegal">
          <span>Privacy Policy</span>
          <span>Terms of Use</span>
        </div>
      </div>
    </footer>
  );
}

function HomePage({ setPage, setSelected }) {
  const featured = PROPERTIES.filter(p => ['Featured', 'Luxury', 'Exclusive'].includes(p.tag)).slice(0, 3);
  const goDetail = (p) => { setSelected(p); setPage('detail'); };

  return (
    <div className="homepage">

      <section className="hero">
        <img src={villa1} alt="hero" className="herobg" />
        <div className="herooverlay" />
        <div className="herocontent">
          <p className="eyebrow">NOVA Realty · Est. 2009</p>
          <h1 className="herotitle">Find Your<br /><span className="heroaccent">Dream Property</span></h1>
          <p className="herosub">Curated luxury real estate across the world's most desirable locations.</p>
          <div className="searchbar">
            <input type="text" className="searchinput" placeholder="Search by city, neighborhood or property type…" />
            <button className="searchbtn" onClick={() => setPage('properties')}>Search</button>
          </div>
          <div className="quicktags">
            {['New York', 'Beverly Hills', 'Malibu', 'San Francisco'].map(c => (
              <button key={c} className="quicktag" onClick={() => setPage('properties')}>{c}</button>
            ))}
          </div>
        </div>
        <div className="herostats">
          {[
            { v: '2,400+', l: 'Properties Listed' },
            { v: '1,800+', l: 'Happy Clients' },
            { v: '48', l: 'Cities Covered' },
            { v: '15', l: 'Years Experience' },
          ].map(s => (
            <div key={s.l} className="stat">
              <span className="statval">{s.v}</span>
              <span className="statlbl">{s.l}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="sectionhdr">
          <p className="eyebrow">Handpicked for you</p>
          <h2 className="sectiontitle">Featured <em>Properties</em></h2>
        </div>
        <div className="grid">
          {featured.map(p => <Card key={p.id} p={p} onView={goDetail} />)}
        </div>
        <div className="sectioncta">
          <button className="btnoutline" onClick={() => setPage('properties')}>View All Properties</button>
        </div>
      </section>

      <section className="section whysection">
        <div className="whygrid">
          <div className="whytext">
            <p className="eyebrow">Why NOVA Realty</p>
            <h2 className="sectiontitle">A Different Kind<br />of <em>Real Estate</em></h2>
            <p className="whydesc">We don't just list properties — we craft experiences. Our team combines market expertise with a deep understanding of what luxury living truly means.</p>
          </div>
          <div className="whycards">
            {[
              { icon: '◈', title: 'Curated Portfolio', desc: 'Every listing is personally vetted for quality, location, and investment potential.' },
              { icon: '◉', title: 'VR Property Tours', desc: 'Explore any property in immersive virtual reality from anywhere in the world.' },
              { icon: '◎', title: 'Expert Agents', desc: 'Decades of combined experience in luxury real estate markets across North America.' },
              { icon: '◆', title: 'Concierge Service', desc: 'White-glove assistance from your first inquiry through to closing and beyond.' },
            ].map(c => (
              <div key={c.title} className="whycard">
                <span className="whyicon">{c.icon}</span>
                <h3 className="whycardtitle">{c.title}</h3>
                <p className="whycarddesc">{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ctaband">
        <h2 className="ctatitle">Ready to Find Your Perfect Property?</h2>
        <p className="ctasub">Speak with one of our expert agents today — no obligation, no pressure.</p>
        <div className="ctabtns">
          <button className="btngold" onClick={() => setPage('properties')}>Browse Properties</button>
          <a href="tel:+12125550100" className="btnghost">Call Us Now</a>
        </div>
      </section>

      <Footer setPage={setPage} />
    </div>
  );
}


function PropertiesPage({ setPage, setSelected }) {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('All');
  const [type, setType] = useState('All');
  const [sort, setSort] = useState('default');

  const TYPES = ['All', 'Penthouse', 'Villa', 'Loft', 'Apartment', 'Studio'];
  const STATUSES = ['All', 'For Sale', 'For Rent'];

  let filtered = PROPERTIES.filter(p => {
    const s = search.toLowerCase();
    const matchSearch = !s || p.title.toLowerCase().includes(s) || p.location.toLowerCase().includes(s) || p.type.toLowerCase().includes(s);
    const matchStatus = status === 'All' || p.status === status;
    const matchType = type === 'All' || p.type === type;
    return matchSearch && matchStatus && matchType;
  });

  if (sort === 'az') filtered = [...filtered].sort((a, b) => a.title.localeCompare(b.title));
  if (sort === 'area') filtered = [...filtered].sort((a, b) => parseInt(b.area.replace(',', '')) - parseInt(a.area.replace(',', '')));

  const goDetail = (p) => { setSelected(p); setPage('detail'); };

  return (
    <div className="propspage">
      <div className="propsheader">
        <p className="eyebrow">Our Portfolio</p>
        <h1 className="propstitle">All Properties</h1>
        <p className="propscount">{filtered.length} properties available</p>
      </div>

      <div className="filtersbar">
        <input
          type="text"
          className="filterinput"
          placeholder="Search location, type…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div className="filtergroup">
          {STATUSES.map(s => (
            <button key={s} className={`chip ${status === s ? 'chipon' : ''}`} onClick={() => setStatus(s)}>{s}</button>
          ))}
        </div>
        <div className="filtergroup">
          {TYPES.map(t => (
            <button key={t} className={`chip ${type === t ? 'chipon' : ''}`} onClick={() => setType(t)}>{t}</button>
          ))}
        </div>
        <select className="filtersort" value={sort} onChange={e => setSort(e.target.value)}>
          <option value="default">Sort: Default</option>
          <option value="az">Name A–Z</option>
          <option value="area">Largest First</option>
        </select>
      </div>

      <div className="propsgrid">
        {filtered.length > 0 ? (
          <div className="grid">
            {filtered.map(p => <Card key={p.id} p={p} onView={goDetail} />)}
          </div>
        ) : (
          <div className="noresults">
            <p className="noresultsicon">◎</p>
            <h3>No properties found</h3>
            <p>Try adjusting your filters or search terms.</p>
            <button className="btngold" onClick={() => { setSearch(''); setStatus('All'); setType('All'); }}>
              Clear Filters
            </button>
          </div>
        )}
      </div>

      <Footer setPage={setPage} />
    </div>
  );
}


function DetailPage({ property: p, setPage, setSelected }) {
  const [activeImg, setActiveImg] = useState(0);
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [sent, setSent] = useState(false);
  const images = [p.img, p.img2];
  const similar = PROPERTIES.filter(x => x.id !== p.id && x.type === p.type).slice(0, 3);

  return (
    <div className="detailpage">
      <div className="breadcrumb">
        <button className="bcbtn" onClick={() => setPage('home')}>Home</button>
        <span>›</span>
        <button className="bcbtn" onClick={() => setPage('properties')}>Properties</button>
        <span>›</span>
        <span className="bccurrent">{p.title}</span>
      </div>

      <div className="gallery">
        <div className="gallerymain">
          <img src={images[activeImg]} alt={p.title} className="galleryimg" />
          <div className="gallerybadge">{p.status}</div>
        </div>
        <div className="gallerythumbs">
          {images.map((img, i) => (
            <button key={i} className={`thumb ${activeImg === i ? 'thumbactive' : ''}`} onClick={() => setActiveImg(i)}>
              <img src={img} alt={`View ${i + 1}`} />
            </button>
          ))}
        </div>
      </div>

      <div className="detailbody">
        <div className="detailmain">
          <div className="detailtitlerow">
            <div>
              <p className="detailtype">{p.type}</p>
              <h1 className="detailtitle">{p.title}</h1>
              <p className="detailloc">◎ {p.location}</p>
            </div>
            <div className="detailpriceblock">
              <div className="detailprice">{p.price}</div>
              <div className="detailpricelbl">{p.status === 'For Rent' ? 'Per month' : 'Sale price'}</div>
            </div>
          </div>

          <div className="detailspecs">
            {[
              { l: 'Bedrooms', v: p.beds },
              { l: 'Bathrooms', v: p.baths },
              { l: 'Area', v: `${p.area} ft²` },
              { l: 'Year Built', v: p.year },
            ].map(s => (
              <div key={s.l} className="specbox">
                <span className="specval">{s.v}</span>
                <span className="speclbl">{s.l}</span>
              </div>
            ))}
          </div>

          <div className="detailsection">
            <h2 className="detailsectiontitle">About this Property</h2>
            <p className="detaildesc">{p.desc}</p>
          </div>

          <div className="detailsection">
            <h2 className="detailsectiontitle">Features & Amenities</h2>
            <div className="featgrid">
              {p.features.map(f => (
                <div key={f} className="featitem">
                  <span className="featcheck">✓</span>
                  <span>{f}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="vrband">
            <span className="vricon">◉</span>
            <div>
              <p className="vrtitle">Virtual Reality Tour Available</p>
              <p className="vrsub">Experience this property in immersive VR — contact the agent to schedule.</p>
            </div>
            <button className="btngold">Schedule VR Tour</button>
          </div>
        </div>

        <aside className="sidebar">
          <div className="agentcard">
            <div className="agentavatar">{p.agent.initials}</div>
            <p className="agentname">{p.agent.name}</p>
            <p className="agentrole">NOVA Realty Agent</p>
            <a href={`tel:${p.agent.phone}`} className="contactbtn">📞 {p.agent.phone}</a>
            <a href={`mailto:${p.agent.email}`} className="contactbtn">✉️ {p.agent.email}</a>
          </div>

          <div className="enquirycard">
            <h3 className="enquirytitle">Request Information</h3>
            {sent ? (
              <div className="sentmsg">
                <p className="senticon">✓</p>
                <p>Thank you! An agent will be in touch shortly.</p>
              </div>
            ) : (
              <form onSubmit={e => { e.preventDefault(); setSent(true); }} className="enquiryform">
                <input className="enqinput" type="text" placeholder="Your Name" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
                <input className="enqinput" type="email" placeholder="Email Address" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
                <input className="enqinput" type="text" placeholder="Phone (optional)" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} />
                <textarea className="enqinput enqtextarea" placeholder={`I'm interested in ${p.title}…`} value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} rows={4} />
                <button type="submit" className="btngold fullw">Send Enquiry</button>
              </form>
            )}
          </div>
        </aside>
      </div>

      {similar.length > 0 && (
        <div className="similarsection">
          <h2 className="similartitle">Similar Properties</h2>
          <div className="grid">
            {similar.map(x => (
              <Card key={x.id} p={x} onView={(prop) => { setSelected(prop); setPage('detail'); window.scrollTo(0, 0); }} />
            ))}
          </div>
        </div>
      )}

      <Footer setPage={setPage} />
    </div>
  );
}


function NotFoundPage({ setPage }) {
  return (
    <div className="notfound">
      <div className="nfbg" />
      <div className="nfcontent">
        <div className="nfcode">404</div>
        <h1 className="nftitle">Property Not Found</h1>
        <p className="nfdesc">The page you're looking for doesn't exist or has been moved. Let us help you find your perfect property.</p>
        <div className="nfbtns">
          <button className="btngold" onClick={() => setPage('home')}>Go Home</button>
          <button className="btnghost" onClick={() => setPage('properties')}>Browse Properties</button>
        </div>
      </div>
    </div>
  );
}


export default function Home() {
  const [page, setPage] = useState('home');
  const [selected, setSelected] = useState(null);

  const goTo = (p) => { setPage(p); window.scrollTo({ top: 0, behavior: 'smooth' }); };

  return (
    <div className="app">
      <Header page={page} setPage={goTo} />
      {page === 'home'       && <HomePage       setPage={goTo} setSelected={setSelected} />}
      {page === 'properties' && <PropertiesPage  setPage={goTo} setSelected={setSelected} />}
      {page === 'detail'     && selected         && <DetailPage property={selected} setPage={goTo} setSelected={setSelected} />}
      {page === 'notfound'   && <NotFoundPage    setPage={goTo} />}
    </div>
  );
}